var _tspan, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChipButtonInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 68,
    viewBox: "0 0 60 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0pwtfa1a3a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 5121",
    style: {
      fill: "none"
    },
    d: "M0 0h45v58H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zwp6ej95pb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 5118",
    style: {
      fill: "#3162d2"
    },
    d: "M0 0h30.832v23.873H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9gqom5wroc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 5119",
    style: {
      fill: "#3162d2"
    },
    d: "M0 0h21.329v15.249H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1966"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 516"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 1025",
    width: 54,
    height: 40,
    rx: 8,
    style: {
      fill: "#e0ebfc"
    }
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": 2,
    transform: "translate(27 26.012)",
    style: {
      fontSize: 18,
      fontFamily: "Pretendard-Bold,Pretendard",
      fontWeight: 700,
      letterSpacing: "-.001em",
      fill: "#3162d2"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: -5.493,
    y: 0
  }, "2")))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1957"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1965",
    style: {
      clipPath: "url(#0pwtfa1a3a)"
    },
    transform: "translate(15 10)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1964"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1963",
    style: {
      clipPath: "url(#0pwtfa1a3a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1959",
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1958"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1957",
    style: {
      clipPath: "url(#zwp6ej95pb)"
    },
    transform: "translate(4.915)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 811",
    d: "M40.54 3.785c.711-.5 1.388-1.058 2.14-1.485 5.52-3.139 11.064-3.088 16.427.287A15.465 15.465 0 0 1 64.1 23.105a1.2 1.2 0 0 1-1.671.616 1.175 1.175 0 0 1-.412-1.732 14.012 14.012 0 0 0 1.671-5.733 13.039 13.039 0 1 0-26.055-.593 12.582 12.582 0 0 0 1.573 6.092c.433.8.415 1.3-.02 1.74a1.161 1.161 0 0 1-1.912-.306 15.271 15.271 0 0 1-2.017-7.4 15.317 15.317 0 0 1 3.406-9.977 1.542 1.542 0 0 0 .145-.288l1.732-1.739",
    transform: "translate(-35.257 .001)",
    style: {
      fill: "#3162d2"
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 812",
    d: "M15.758 38.406c.007-.3.016-.524.016-.743V15.884a4.6 4.6 0 0 1 2.489-4.4 4.487 4.487 0 0 1 6.518 3.459c.152 1.943.066 3.9.087 5.858 0 .2.012.4.018.613a4.738 4.738 0 0 1 6.7 3.427 4.633 4.633 0 0 1 6.636 3.2 14.821 14.821 0 0 1 2.691-.281A4.476 4.476 0 0 1 45 32.376c-.191 4.649-.35 9.3-.7 13.94a12.847 12.847 0 0 1-12.037 11.617 64.07 64.07 0 0 1-8.164-.136 12.072 12.072 0 0 1-7.51-3.878c-5.088-5.107-10.153-10.238-15.276-15.31-2.174-2.152-1.618-5.3 1.452-6.524a5.34 5.34 0 0 1 5.447.835q3.582 2.643 7.179 5.267c.089.065.189.114.368.22m-4.8 6.461c2.465 2.474 4.942 4.938 7.392 7.426a10.041 10.041 0 0 0 6.484 3.219 59.2 59.2 0 0 0 6.781.076 10.477 10.477 0 0 0 10.36-9.964c.334-4.434.455-8.884.654-13.327a2.071 2.071 0 0 0-1.217-1.978 2.128 2.128 0 0 0-3.1 1.7 2.755 2.755 0 0 1-.321 1.093 1.025 1.025 0 0 1-1.236.378 1.21 1.21 0 0 1-.829-1.251c-.015-1.117.02-2.234-.009-3.35a2.2 2.2 0 0 0-2.147-2.19 2.168 2.168 0 0 0-2.184 2.2c-.021.651 0 1.3 0 1.954 0 .558.017 1.119-.036 1.672a1.152 1.152 0 0 1-2.138.439 2.176 2.176 0 0 1-.19-.964c-.016-2.1-.013-4.206-.006-6.31a2.236 2.236 0 0 0-.862-1.905 2.044 2.044 0 0 0-2.253-.237 2.1 2.1 0 0 0-1.223 2.029c-.009 2.1 0 4.206 0 6.31 0 1.089-.422 1.671-1.2 1.659s-1.169-.543-1.169-1.631V16.002a5.837 5.837 0 0 0-.035-.78 2.148 2.148 0 0 0-3.275-1.544 2.3 2.3 0 0 0-1.056 2.189q.01 12.173 0 24.345c0 .186.005.373-.005.558a1.168 1.168 0 0 1-.654 1.085 1.2 1.2 0 0 1-1.307-.153q-1.753-1.279-3.5-2.562c-2.083-1.519-4.157-3.051-6.256-4.546a2.766 2.766 0 0 0-3.05-.179A1.389 1.389 0 0 0 3 36.903c2.683 2.624 5.309 5.305 7.958 7.963"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1962",
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1961"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1960",
    style: {
      clipPath: "url(#9gqom5wroc)"
    },
    transform: "translate(9.663 4.836)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 813",
    d: "M72.235 37.884c4.648-4.548 11.678-4.377 15.719.267A10.5 10.5 0 0 1 90.04 48.8a1.195 1.195 0 1 1-2.261-.7 8.877 8.877 0 0 0 .1-5.375A8.282 8.282 0 1 0 72.1 47.791c.042.142.088.285.12.429a1.188 1.188 0 1 1-2.274.673 10.841 10.841 0 0 1 2.284-11.01",
    transform: "translate(-69.323 -34.568)",
    style: {
      fill: "#3162d2"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 814",
    d: "M25.672 126.995c-2.649-2.658-5.276-5.34-7.958-7.964a1.389 1.389 0 0 1 .377-2.487 2.766 2.766 0 0 1 3.05.179c2.1 1.5 4.173 3.028 6.256 4.546q1.753 1.278 3.5 2.561a1.2 1.2 0 0 0 1.308.153 1.168 1.168 0 0 0 .654-1.085c.01-.186.005-.372.005-.558V97.995a2.3 2.3 0 0 1 1.056-2.189 2.148 2.148 0 0 1 3.257 1.551 5.834 5.834 0 0 1 .035.78v15.914c0 1.088.383 1.619 1.169 1.631s1.2-.57 1.2-1.659c0-2.1-.006-4.207 0-6.31a2.1 2.1 0 0 1 1.223-2.029 2.044 2.044 0 0 1 2.253.237 2.236 2.236 0 0 1 .862 1.905c-.006 2.1-.01 4.207.007 6.31a2.176 2.176 0 0 0 .19.965 1.152 1.152 0 0 0 2.138-.439c.053-.554.032-1.115.036-1.672 0-.651-.017-1.3 0-1.954a2.168 2.168 0 0 1 2.184-2.2 2.2 2.2 0 0 1 2.147 2.19c.029 1.116-.006 2.233.009 3.35a1.21 1.21 0 0 0 .829 1.251 1.025 1.025 0 0 0 1.236-.377 2.761 2.761 0 0 0 .321-1.094 2.127 2.127 0 0 1 3.1-1.7 2.071 2.071 0 0 1 1.218 1.978c-.2 4.444-.32 8.894-.654 13.327a10.477 10.477 0 0 1-10.36 9.964 59.2 59.2 0 0 1-6.781-.076 10.041 10.041 0 0 1-6.484-3.219c-2.451-2.489-4.927-4.952-7.392-7.426",
    transform: "translate(-14.714 -82.128)",
    style: {
      fill: "#fff"
    }
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipButtonInfo);
export default __webpack_public_path__ + "static/media/chip_button_info.917fec3e9f45c320d8be9ca8413de01c.svg";
export { ForwardRef as ReactComponent };